import { BaseAPIError } from './BaseAPIError'

export class UnAuthorizationAPIError extends BaseAPIError {}
